import { IncidentDocumentation} from "./IncidentDocumentation";

export default IncidentDocumentation;
